module.exports = __webpack_public_path__ + "img/fire2.c184b887.jpg";